/**
 * Convert old 'urgent' field to new 'priority' field for backward compatibility
 * @param {Object} data - The request data object
 * @returns {Object} - Data with priority field
 */
export function convertUrgentToPriority(data) {
  const converted = { ...data };
  
  // If priority already exists, use it
  if (converted.priority) {
    return converted;
  }
  
  // Convert old urgent field to priority
  if (converted.urgent === true) {
    converted.priority = "High";
  } else if (!converted.priority) {
    converted.priority = "Low";
  }
  
  return converted;
}
